import api from "@/api/";
import { PaginationModel } from "../types";

export default class BannerApi {
  static async list(
    type:any,
    options:
      | {
          filter?: {
            role?: string[];
          };
        }
      | PaginationModel
  ) {
    return await api.get(`banner/list/page/${type}`, options);
  }

  static async save(data?:any ) {
    return await api.post(`banner/insert`,data);
  }

  static async delete(bannerCode?: any) {
    return await api.post(`banner/delete/${bannerCode}`);
  }

  static async changeStatus(bannerCode:any , status:any) {
    return await api.post(`banner/status/${bannerCode}/${status}`);
  }
}
